// Checkr's allowed character set for candidate name fields:
// Latin letters (with accents), digits, space, hyphen, apostrophe, period, comma.
// Anything outside this set (e.g. Cyrillic letters that visually resemble Latin)
// causes Checkr to reject the candidate, which fails
// InitiateBackgroundCheckOnShiftAssignmentJob.
export const VALID_WORKER_NAME_REGEX = /^[a-zA-Z0-9ªµºÀ-ÖØ-öø-ÿ\-'., ]*$/;
